import { FC } from "react";

import styled from "@emotion/styled";
import iconCheck from "src/ui/assets/icon-check-gradient.svg";
import CompletedWeekBadge from "../WeightReadings/CompletedWeekBadge";

/**
 * Shown in place of the protein ring once the daily protein target is met. It
 * reuses the weight-streak reward seal (the slowly-spinning scalloped badge)
 * with a checkmark at its centre instead of the weight-scale icon.
 */
const Wrapper = styled.div`
  width: 88px;
  height: 88px;
  flex-shrink: 0;
`;

const ProteinTargetBadge: FC<{ "aria-label"?: string }> = ({
  "aria-label": ariaLabel
}) => (
  <Wrapper role="img" aria-label={ariaLabel}>
    <CompletedWeekBadge icon={iconCheck} iconAlt="" speed="12800ms" />
  </Wrapper>
);

export default ProteinTargetBadge;
